// extracted by mini-css-extract-plugin
export default {"title":"SubscriptionTrusted_title__SC2ni","companies":"SubscriptionTrusted_companies__+T-7D","company":"SubscriptionTrusted_company__jOXU+"};